import { PermissionResource } from '@entities/tenant/permission';

import { requirePermission } from '../../../require-permission';

export const usersLoader = requirePermission(PermissionResource.TenantUsers);
